module.exports = __webpack_public_path__ + "static/media/menu.9b09ca81.svg";